'use client';

import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';

export function AsyncLDWrapper({
  children,
}: {
  children: React.ReactNode;
}): React.ReactNode {
  const ldClient = useLDClient();
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    ldClient?.waitForInitialization().then(() => {
      setIsReady(true);
    });
  }, [ldClient]);

  return isReady ? children : null;
}
